import { ArrowLeft } from "lucide-react";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";

const getStatusColor = (status) => {
  const colors = {
    pending: "bg-amber-100 text-amber-800 border-amber-300",
    in_progress: "bg-blue-100 text-blue-800 border-blue-300",
    completed: "bg-emerald-100 text-emerald-800 border-emerald-300",
  };
  return colors[status] || "bg-slate-100 text-slate-800";
};

export const JobDetailHeader = ({ job, onBack }) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={onBack}
          className="rounded-sm"
          data-testid="back-btn"
        >
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-slate-800" data-testid="job-title">
            Job Details
          </h1>
          <p className="text-slate-500 text-sm">
            {job.customer_name} • {job.excavator_model}
          </p>
        </div>
      </div>
      <Badge className={`${getStatusColor(job.status)} uppercase px-3 py-1`} data-testid="job-status">
        {job.status?.replace("_", " ")}
      </Badge>
    </div>
  );
};

export default JobDetailHeader;
